module.exports = __webpack_public_path__ + "assets/img/slat_open6_AR.7a243106.svg";